import { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import FormContainer from '../Components/FormContainer';
import BackButton from '../Components/BackButton';
import { Link } from 'react-router-dom';

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setMsg(''); setErr(''); setBusy(true);
    try {
      const res = await fetch('/api/users/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: String(email).trim().toLowerCase() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || 'Failed to send reset link');
      setMsg('If that email exists, we sent a reset link.');
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <FormContainer>
      <h1>Forgot Password</h1>
      {msg && <Alert variant="success">{msg}</Alert>}
      {err && <Alert variant="danger">{err}</Alert>}
      <Form onSubmit={submitHandler}>
        <Form.Group className="my-3" controlId="email">
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        <div className="d-flex gap-3 align-items-center">
          <Button type="submit" variant="primary" disabled={busy}>Send reset link</Button>
          {/* Quick way to go back to Sign In */}
          <BackButton
            to="/login"
            variant="secondary"
            className=""
          >
            Back to Sign In
          </BackButton>
        </div>
      </Form>
      <div className="mt-3">
        <Link to="/login">Return to Sign In</Link>
      </div>
    </FormContainer>
  );
};

export default ForgotPasswordScreen;
